export default function (data, nameApp) {
  data.set().setState({
    openApp: data.openApp.filter((d) => d !== nameApp)
  });
}
